
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'Staff',

  components: {
    WpImage,
  },

  props: {
    staffId: {
      type: Number,
      required: true,
    },
    onlyImage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    staff() {
      return this.$store.getters.getStaff(this.staffId);
    },
  },
};
